import { useRef, useState, useEffect, useCallback, cloneElement } from 'react';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

var Schema = require('async-validator');

Schema = Schema.default ? Schema.default : Schema;

function validate(_a, _b, ns) {
  var fieldsOptions = __rest(_a, []);

  var values = __rest(_b, []);

  return new Promise(function (resolve, reject) {
    ns = ns || Object.keys(fieldsOptions);
    var fieldsRule = {};

    for (var name_1 in fieldsOptions) {
      if (ns.includes(name_1)) {
        fieldsRule[name_1] = fieldsOptions[name_1].rules || [{
          required: false
        }];
      }
    }

    for (var name_2 in values) {
      if (!ns.includes(name_2)) {
        delete values[name_2];
      }
    }

    new Schema(fieldsRule).validate(values, function (errors) {
      if (errors) {
        var errorsObj = {};

        for (var _i = 0, _a = errors || []; _i < _a.length; _i++) {
          var _b = _a[_i],
              field = _b.field,
              message = _b.message;
          errorsObj[field] = [{
            message: message,
            field: field
          }];
        }

        reject({
          errors: errorsObj,
          values: values
        });
      } else {
        resolve(values);
      }
    });
  });
}

function useForm(createOptions) {
  var _this = this;

  if (createOptions === void 0) {
    createOptions = {};
  }

  var cacheData = useRef({
    fieldsTouched: {},
    fieldsValidated: {}
  });
  var fieldsOptions = useRef({});

  var _a = useState({}),
      errors = _a[0],
      setErrors = _a[1];

  var _b = useState({}),
      values = _b[0],
      setValues = _b[1];

  var valuesRef = useRef(values);
  useEffect(function () {
    valuesRef.current = values;
  }, [values]);
  useEffect(function () {
    var _a = cacheData.current,
        fieldsChanged = _a.fieldsTouched,
        currentField = _a.currentField;

    if (currentField === undefined || !fieldsChanged[currentField]) {
      return;
    }

    validate(fieldsOptions.current, values, [currentField]).then(function () {
      setErrors(function (errors) {
        var errs = _assign({}, errors);

        delete errs[currentField];
        return errs;
      });
    }).catch(function (_a) {
      var newErrors = _a.errors;
      setErrors(function (oldErrors) {
        return _assign({}, oldErrors, newErrors);
      });
    });
  }, [values, fieldsOptions]);
  useEffect(function () {
    if (createOptions.onValuesChange) {
      createOptions.onValuesChange(values, values);
    }
  }, [values, createOptions]);
  var getFieldProps = useCallback(function (name, options) {
    var _a;

    if (options === void 0) {
      options = {};
    }

    var n = name instanceof Array ? name[0] : name;
    var _b = fieldsOptions.current[n],
        _c = _b.trigger,
        trigger = _c === void 0 ? 'onChange' : _c,
        _d = _b.valuePropName,
        valuePropName = _d === void 0 ? 'value' : _d;
    var props = (_a = {}, _a[trigger] = function (e) {
      var value = e && e.target ? e.target.value : e;
      setValues(function (oldValues) {
        var _a;

        var currentValue = {};

        if (name instanceof Array && value instanceof Array) {
          name.forEach(function (n, index) {
            return currentValue[n] = value[index];
          });
        } else {
          currentValue[n] = value;
        } // eslint-disable-next-line @typescript-eslint/no-object-literal-type-assertion


        var values = _assign({}, oldValues, currentValue);

        var current = cacheData.current;
        current.currentField = n;
        current.fieldsTouched[n] = true;

        if (createOptions.onValuesChange) {
          createOptions.onValuesChange(( // eslint-disable-next-line @typescript-eslint/no-object-literal-type-assertion
          _a = {}, _a[n] = value, _a), values);
        }

        valuesRef.current = values;
        return values;
      });
    }, _a['data-__field'] = {
      errors: errors[n]
    }, _a['data-__meta'] = {
      validate: [{
        rules: options.rules
      }]
    }, _a);

    if (name instanceof Array) {
      var value_1 = [];
      name.forEach(function (n) {
        value_1.push(values[n]);
      });
      props[valuePropName] = value_1;
    } else {
      props[valuePropName] = values[name];
    }

    return props;
  }, [values, createOptions, errors]);
  var objFilter = useCallback(function (obj, ns) {
    if (ns) {
      Object.keys(obj).forEach(function (name) {
        if (!ns.includes(name)) {
          delete obj[name];
        }
      });
    }

    return obj;
  }, []);
  var resetFields = useCallback(function (ns) {
    var current = cacheData.current;
    delete current.currentField;

    if (!ns) {
      setValues(function () {
        return {};
      });
      setErrors(function () {
        return {};
      });
      Object.keys(current).forEach(function (name) {
        return current[name] = {};
      });
    } else {
      ns.forEach(function (name) {
        delete current.fieldsTouched[name];
        setValues(function (values) {
          var _a;

          return _assign({}, values, (_a = {}, _a[name] = undefined, _a));
        });
        setErrors(function (oldErrors) {
          var errors = _assign({}, oldErrors);

          delete errors[name];
          return errors;
        });
      });
    }
  }, []);
  var validateFields = useCallback(function (ns, options) {
    if (options === void 0) {
      options = {};
    }

    return new Promise(function (resolve, reject) {
      return __awaiter(_this, void 0, void 0, function () {
        var fieldsValidated;
        return __generator(this, function (_a) {
          fieldsValidated = cacheData.current.fieldsValidated;

          if (ns) {
            ns.forEach(function (name) {
              fieldsValidated[name] = true;
            });
          }

          if (options.force) {
            Object.keys(fieldsValidated).forEach(function (name) {
              if (fieldsValidated[name]) {
                delete errors[name];
              }
            });
          }

          validate(fieldsOptions.current, valuesRef.current, ns).then(function (values) {
            return resolve(values);
          }).catch(function (a) {
            var newErrors = a.errors;
            setErrors(function (errors) {
              return _assign({}, errors, newErrors);
            });
            reject(newErrors[Object.keys(newErrors)[0]][0]);
          });
          return [2
          /*return*/
          ];
        });
      });
    });
  }, [errors]);
  var reRenderRef = useRef(true);
  reRenderRef.current = true;
  var getFieldDecorator = useCallback(function (name, options) {
    if (options === void 0) {
      options = {
        rules: [{
          required: false
        }]
      };
    }

    if (reRenderRef.current) {
      fieldsOptions.current = {};
      reRenderRef.current = false;
    }

    var setOptions = function setOptions(name) {
      fieldsOptions.current[name] = options;
      values[name] = values[name] !== undefined || cacheData.current.fieldsTouched[name] ? values[name] : options.initialValue;
    };

    valuesRef.current = values;

    if (name instanceof Array) {
      name.forEach(function (n) {
        return setOptions(n);
      });
    } else {
      setOptions(name);
    }

    var props = getFieldProps(name, options);
    return function (fieldElem) {
      var _a;

      var _b = options.trigger,
          trigger = _b === void 0 ? 'onChange' : _b;
      return cloneElement(fieldElem, _assign({}, fieldElem.props, props, (_a = {}, _a[trigger] = function (e) {
        props[trigger](e);

        if (fieldElem.props[trigger]) {
          fieldElem.props[trigger](e);
        }
      }, _a)));
    };
  }, [values, getFieldProps]);
  var setFieldsValue = useCallback(function (_a) {
    var newValues = __rest(_a, []);

    return setValues(function (oldValues) {
      var values = _assign({}, oldValues, newValues);

      valuesRef.current = values;
      return values;
    });
  }, []);
  var getFieldsValue = useCallback(function (ns) {
    var result = _assign({}, valuesRef.current);

    objFilter(result, ns);
    return result;
  }, [objFilter]);
  var getFieldValue = useCallback(function (name) {
    return valuesRef.current[name];
  }, []);
  var getFieldsError = useCallback(function (ns) {
    var result = _assign({}, errors);

    objFilter(result, ns);
    return result;
  }, [errors, objFilter]);
  var getFieldError = useCallback(function (name) {
    return errors[name] || [];
  }, [errors]);
  var setFields = useCallback(function (fields) {
    setValues(function (oldValues) {
      var values = _assign({}, oldValues);

      for (var name_3 in fields) {
        var value = fields[name_3].value;
        values[name_3] = value;
      }

      return values;
    });
    setErrors(function (oldErrors) {
      var errors = _assign({}, oldErrors);

      var _loop_1 = function _loop_1(name_4) {
        var errorArr = fields[name_4].errors || [];
        errors[name_4] = errorArr.map(function (_a) {
          var message = _a.message;
          return {
            message: message,
            field: name_4
          };
        });
      };

      for (var name_4 in fields) {
        _loop_1(name_4);
      }

      return errors;
    });
  }, []);
  var isFieldTouched = useCallback(function (name) {
    return Boolean(cacheData.current.fieldsTouched[name]);
  }, []);
  var isFieldsTouched = useCallback(function (names) {
    if (names === void 0) {
      names = [];
    }

    return names.some(function (x) {
      return Boolean(cacheData.current.fieldsTouched[x]);
    });
  }, []);
  return {
    errors: errors,
    values: values,
    resetFields: resetFields,
    validateFields: validateFields,
    getFieldDecorator: getFieldDecorator,
    setFieldsValue: setFieldsValue,
    getFieldsValue: getFieldsValue,
    getFieldValue: getFieldValue,
    getFieldsError: getFieldsError,
    getFieldError: getFieldError,
    setFields: setFields,
    isFieldTouched: isFieldTouched,
    isFieldsTouched: isFieldsTouched
  };
}

export default useForm;